import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Type } from '@spotify-internal/encore-creator-web';

import styles from '../index.module.scss';
import { AgeDemographicsChart } from '../../../../components/Shared/Charts/AgeDemographicsChart';
import { LoadingIndicator } from '../../../../components/Shared/LoadingIndicator';
import { GenderDemographics } from '../../../../types';
import { FormattedMessage } from 'react-intl';

type Props = {
  loading?: boolean;
  ageData: GenderDemographics[];
};

export function AgeChart(props: Props) {
  return (
    <div className={styles.wrapper} data-qa="episode-demographics-age-chart">
      <Type as="h1" variant={Type.heading3}>
        <FormattedMessage id="episode.age.title" defaultMessage="Age" />
      </Type>
      {props.loading ? (
        <div style={{ width: '100%', height: '350px' }}>
          <LoadingIndicator />
        </div>
      ) : (
        <AgeDemographicsChart ageData={props.ageData} />
      )}
    </div>
  );
}
